import { authRequest } from './index.js'
import { formatResponse } from '@/utils/errorHandler'

/**
 * Retrieve all payments with pagination
 * @param {Object} params - Query parameters (page, per_page, etc.)
 * @returns {Object} - Response object with payments list or error
 */
export async function get_payments(params = {}) {
  try {
    const result = await authRequest.get('/payments', { params })
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Retrieve a specific payment by ID
 * @param {string|number} id - Payment ID
 * @returns {Object} - Response object with payment data or error
 */
export async function get_payment(id) {
  try {
    const result = await authRequest.get(`/payments/${id}`)
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Get payment statistics
 * @returns {Object} - Response object with payment stats or error
 */
export async function get_payment_stats() {
  try {
    const result = await authRequest.get('/payments/stats')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Get payment statistics
 * @returns {Object} - Response object with payment stats or error
 */
export async function getInvoiceSummary() {
  try {
    const result = await authRequest.get('/payments/invoice_summary')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

export async function downloadInvoice(paymentId){
  try {
    const result = await authRequest.get(
      `/payments/${paymentId}/download_invoice`,
      { responseType: 'blob' }
    );
    // Return the full result object to preserve headers
    return { error: false, data: result };
  } catch (error) {
    return formatResponse(null, true, error);
  }
}